// extracted by mini-css-extract-plugin
export default {"lang":"LangSelector_lang__fQiuW","active":"LangSelector_active__UTlgd"};